import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, User, ShieldCheck } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

const LOGO_URL = "/logo-prenova.png";

export default function SuperAdminLogin() {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    if (localStorage.getItem("superadmin_token")) {
        return <Navigate to="/adminrenova" replace />;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const r = await api.post("/superadmin/login", { username, password });
            localStorage.setItem("superadmin_token", r.data.token);
            localStorage.setItem("superadmin_username", r.data.admin.username);
            toast.success("Benvenuto in Prenova by Renova360");
            navigate("/adminrenova");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Credenziali non valide");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-ink px-6 grain relative overflow-hidden" data-testid="superadmin-login-page">
            <div className="absolute inset-0 bg-gradient-to-br from-ink via-ink-surface to-ink" />
            <div className="absolute inset-0 opacity-[0.03]" style={{
                backgroundImage: "radial-gradient(circle at 30% 20%, #d4af37 0%, transparent 40%), radial-gradient(circle at 70% 80%, #d4af37 0%, transparent 40%)"
            }} />
            <div className="max-w-md w-full relative z-10">
                <div className="text-center mb-10">
                    <div className="w-40 h-40 rounded-sm mx-auto mb-6 overflow-hidden ring-2 ring-gold/60 shadow-[0_0_40px_rgba(212,175,55,0.3)] bg-[#1a1f3a]">
                        <img src={LOGO_URL} alt="Prenova by Renova360" className="w-full h-full object-contain" />
                    </div>
                    <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/30 px-4 py-1.5 rounded-sm mb-4">
                        <ShieldCheck size={12} className="text-gold" strokeWidth={1.5} />
                        <span className="text-gold text-[10px] tracking-[0.4em] uppercase">Super Admin · Renova</span>
                    </div>
                    <h1 className="font-serif text-4xl text-white">
                        Pannello <span className="italic text-gold">Renova</span>
                    </h1>
                    <p className="text-gray-400 mt-3 text-sm">Console di amministrazione multi-tenant.</p>
                </div>

                <form onSubmit={handleSubmit} className="bg-ink-surface border border-white/10 rounded-sm p-8 space-y-5">
                    <div className="relative">
                        <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={16} strokeWidth={1.5} />
                        <input type="text" placeholder="Username" value={username}
                            onChange={(e) => setUsername(e.target.value)} required
                            data-testid="superadmin-username-input"
                            className="w-full pl-10 pr-3 py-3 bg-transparent border border-white/20 rounded-sm text-white placeholder-gray-500 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold" />
                    </div>
                    <div className="relative">
                        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={16} strokeWidth={1.5} />
                        <input type="password" placeholder="Password" value={password}
                            onChange={(e) => setPassword(e.target.value)} required
                            data-testid="superadmin-password-input"
                            className="w-full pl-10 pr-3 py-3 bg-transparent border border-white/20 rounded-sm text-white placeholder-gray-500 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold" />
                    </div>
                    <button type="submit" disabled={loading}
                        data-testid="superadmin-login-submit-btn"
                        className="w-full bg-gold text-black font-semibold py-3 rounded-sm hover:bg-gold-light transition-colors disabled:opacity-50 tracking-widest uppercase text-sm">
                        {loading ? "Accesso..." : "Accedi"}
                    </button>
                </form>
            </div>
        </div>
    );
}
